import { PdfFormatDefaults, Section } from "../core/pdf/types";


export const DesignerMessages = {
	BLUR: "blur",
	FOCUS: "focus",

	GET_REF: "get-ref",
	GET_CONTEXT: "get-context",

	GET_SEGMENTS: "get-segments",

	REFRESH: "refresh",
	REFRESH_ROOT: "refresh-root",

	FOCUS_CHANGED: "focus-changed",
	FOCUS_REFRESH: "focus-refresh",

	EDIT_FIELD: "edit-field",

	CHANGED: "changed",

	ADD_REGION: "add-region"
}

const typeNames = {
	"p": "Paragraph",
	"heading": "Heading",
	"listItem": "List Item",
	"list": "List",
	"hr": "Horizontal Rule",
	"header": "Header",
	"footer": "Footer",
	"section": "Section",
	"table": "Table",
	"tableRow": "Table Row",
	"tableCell": "Table Cell",
	"group": "Group",
	"region": "Region",
	"image": "Image",
	"sub-report": "Sub Report",
	"sig-block": "Signature",
	"toc": "Table of Contents",
	"tag": "Tag",
	"pagebreak": "Page Break",
	"link": "Link",
} as any;

export function getTypeName(type?: string) {
	if (!type) return "";
	const result = typeNames[type];
	if (!result) return "";
	return result;
}
